'use client';

import { useState, useCallback } from 'react';
import { useAddClickButtonGtag } from '@/hooks/useGtag.hook';
import OrderGuideModal from './order-guide-modal';
import { outlineButtonClassName } from './cta.constants';

const GTAG = {
  label: 'family-insight-order-guide',
  position: 'main_cta',
} as const;

interface OrderGuideButtonProps {
  orderGuide: string;
  orderGuideLink: string;
  orderGuideModalTitle: string;
}

export default function OrderGuideButton({
  orderGuide,
  orderGuideLink,
  orderGuideModalTitle,
}: OrderGuideButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const addGtag = useAddClickButtonGtag({
    label: GTAG.label,
    position: GTAG.position,
  });

  const handleClick = useCallback(() => {
    addGtag();
    setIsModalOpen(true);
  }, [addGtag]);

  const handleClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className={`hidden w-auto items-center justify-center px-5 py-[10px] text-sh1 font-semibold md:flex ${outlineButtonClassName}`}
      >
        {orderGuide}
      </button>
      <OrderGuideModal
        isOpen={isModalOpen}
        onClose={handleClose}
        title={orderGuideModalTitle}
        videoUrl={orderGuideLink}
      />
    </>
  );
}
